// extracted by mini-css-extract-plugin
export default {"countryOptionLabel":"WNPFeaqC","countryFlag":"gDkRtgzP","TelephoneTextboxBody":"bKYlLbQS","countryNameAndCode":"hDcYE3jd","countrySelector":"pYig2Hi7","invalid":"AiH0649s"};